import { useEffect, useState } from "react";
import { viewDms } from "../services/chatService";
import { viewConversationDms } from "../services/chatService";

export const useDmsPanel = (
  skipLoader = false,
  refreshDependency = 0,
  searchTerm = ""
) => {
  const [directMessages, setDirectMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    const fetchDMsData = async () => {
      try {
        if (!skipLoader) {
          setLoading(true);
        }
        await delay(500); // ⏳ Only add delay when loader is shown

        const response = await viewDms(searchTerm);
        setDirectMessages(response.direct_chat_data);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };
    fetchDMsData();
  }, [skipLoader, refreshDependency, searchTerm]);
  return { directMessages, loading };
};

export const useConversationDms = (refreshConv) => {
  const [loadingConv, setLoadingConv] = useState(true);
  const [sendingmessage, setSendingmessage] = useState([]);
  const [recivingMessage, setRecivingmessage] = useState([]);
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    const fetchConversation = async () => {
      try {
        setLoadingConv(true);
        setSendingmessage([]);
        setRecivingmessage([]);
        await delay(500);

        const response = await viewConversationDms();
        if (
          response.get_single_message &&
          response.get_single_message.length > 0
        ) {
          setSendingmessage(
            response.get_single_message[0].sending_messages || []
          );
          setRecivingmessage(
            response.get_single_message[0].receiving_messages || []
          );
        } else {
          setSendingmessage([]);
          setRecivingmessage([]);
        }
      } catch (error) {
        setSendingmessage([]);
        setRecivingmessage([]);
      } finally {
        setLoadingConv(false);
      }
    };
    fetchConversation();
  }, [refreshConv]);

  return { loadingConv, sendingmessage, recivingMessage };
};
